import { createContext, useContext, ReactNode } from 'react';

interface ChatUIConfig {
  showRating: boolean;
  showImageUpload: boolean;
  showAudioRecorder: boolean;
  mode: 'authenticated' | 'public';
}

const defaultConfig: ChatUIConfig = {
  showRating: true,
  showImageUpload: true,
  showAudioRecorder: true,
  mode: 'authenticated',
};

const ChatUIContext = createContext<ChatUIConfig>(defaultConfig);

interface ChatUIProviderProps {
  children: ReactNode;
  config?: Partial<ChatUIConfig>;
}

export function ChatUIProvider({ children, config = {} }: ChatUIProviderProps) {
  const contextValue: ChatUIConfig = {
    ...defaultConfig,
    ...config,
  };

  return <ChatUIContext.Provider value={contextValue}>{children}</ChatUIContext.Provider>;
}

export function useChatUI(): ChatUIConfig {
  const context = useContext(ChatUIContext);
  if (context === undefined) {
    // Fallback to default config if not within provider
    return defaultConfig;
  }
  return context;
}
